// Tiny utility for conditional class composition — mirrors the inline `cn`
// helpers used throughout packages/web. Filters falsy values and joins
// the rest with a space so callers can write cx("base", active && "active").
export function cx(...args: (string | false | null | undefined)[]): string {
  return args.filter(Boolean).join(" ");
}
